import React from "react"

import i18n from "@/i18n"

import VenueGoogleMap from "../venue_google_map"

type MapPreviewProps = {
  latitude?: number | null
  longitude?: number | null
  venueName?: string | null
  mapQuery: string | null
  height: string
}

const STYLES = {
  mapContainer: "mb-6 rounded-[5px] border border-[#f1f2f5] overflow-hidden",
} as const

const MapPreview: React.FC<MapPreviewProps> = ({ latitude, longitude, venueName, mapQuery, height }) => {
  if (latitude != null && longitude != null) {
    return (
      <div className={`${STYLES.mapContainer} ${height}`} data-testid="public-venue-info-map">
        <VenueGoogleMap latitude={latitude} longitude={longitude} venueName={venueName} />
      </div>
    )
  }

  if (!mapQuery) return null

  return (
    <div className={`${STYLES.mapContainer} ${height}`} data-testid="public-venue-info-map">
      <iframe
        title={i18n.t("app.public.venue.venue_info.title")}
        width="100%"
        height="100%"
        style={{ border: 0 }}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        src={`https://maps.google.com/maps?q=${encodeURIComponent(mapQuery)}&output=embed&z=15`}
      />
    </div>
  )
}

export default MapPreview
